module.exports = __webpack_public_path__ + "img/feature_buy_zh.4e66f1ab.png";